import "./internal-mobility-metrics-report.css"

const InternalMobilityMetricsReport = (props) => {
  // Accept the actual prop sent from parent (comparisonData),
  // but still fallback to comparisonResult for safety
  const comparisonResult = props?.comparisonData ?? props?.comparisonResult ?? null;

  console.log("Internal Mobility Comparison Result:", comparisonResult);

  const data = comparisonResult?.mobilityMetricsShortReport || {};
  const deptDetails = comparisonResult?.detailedReport?.departmentDetails || {};

  const deptAName = deptDetails?.deptA?.name || "Department A"
  const deptBName = deptDetails?.deptB?.name || "Department B"

  const deptASize = Number(data.deptASize ?? 0)
  const deptBSize = Number(data.deptBSize ?? 0)
  const deptAOps = Number(data.deptAMobilityOpportunities ?? 0)
  const deptBOps = Number(data.deptBMobilityOpportunities ?? 0)
  const aScore = Number(data.deptAAvgMaxMobilityScore ?? 0)
  const bScore = Number(data.deptBAvgMaxMobilityScore ?? 0)

  const clamp = (v) => Math.max(0, Math.min(100, Number.isFinite(v) ? v : 0))

  return (
    <div className="dd-imm-short-report-container">
      <div className="dd-imm-report-header">
        <h3>Internal Mobility Metrics</h3>
        <p>Quick overview of internal mobility effectiveness between the selected departments</p>
      </div>

      <div className="dd-imm-comparison-summary">
        {/* Department sizes */}
        <div className="dd-imm-summary-card">
          <div className="dd-imm-summary-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <div className="dd-imm-summary-content">
            <div className="dd-imm-summary-value">{deptASize}</div>
            <div className="dd-imm-summary-label">{`${deptAName} Department Size`}</div>
          </div>
        </div>

        <div className="dd-imm-summary-card">
          <div className="dd-imm-summary-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <div className="dd-imm-summary-content">
            <div className="dd-imm-summary-value">{deptBSize}</div>
            <div className="dd-imm-summary-label">{`${deptBName} Department Size`}</div>
          </div>
        </div>

        {/* Mobility opportunities */}
        <div className="dd-imm-summary-card">
          <div className="dd-imm-summary-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
          </div>
          <div className="dd-imm-summary-content">
            <div className="dd-imm-summary-value">{deptAOps}</div>
            <div className="dd-imm-summary-label">{`${deptAName} Mobility Opportunities`}</div>
          </div>
        </div>

        <div className="dd-imm-summary-card">
          <div className="dd-imm-summary-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
          </div>
          <div className="dd-imm-summary-content">
            <div className="dd-imm-summary-value">{deptBOps}</div>
            <div className="dd-imm-summary-label">{`${deptBName} Mobility Opportunities`}</div>
          </div>
        </div>
      </div>

      {/* Average Internal Mobility Metrics */}
      <div className="dd-imm-metrics-comparison">
        <h3>Average Maximum Internal Mobility Score</h3>
        <div className="dd-imm-metrics-chart">
          <div className="dd-imm-metric-bar-container">
            <div className="dd-imm-metric-info">
              <span className="dd-imm-metric-name">{`${deptAName} Department`}</span>
            </div>
            <div className="dd-imm-metric-bar">
              <div className="dd-imm-metric-fill" style={{ width: `${clamp(aScore)}%` }} />
              <span className="dd-imm-metric-value">{`${aScore.toFixed(2)}%`}</span>
            </div>
          </div>

          <div className="dd-imm-metric-bar-container">
            <div className="dd-imm-metric-info">
              <span className="dd-imm-metric-name">{`${deptBName} Department`}</span>
            </div>
            <div className="dd-imm-metric-bar">
              <div className="dd-imm-metric-fill" style={{ width: `${clamp(bScore)}%` }} />
              <span className="dd-imm-metric-value">{`${bScore.toFixed(2)}%`}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Analysis Overview */}
      <div className="dd-imm-insights-section">
        <h3>Analysis Overview</h3>
        <div className="dd-imm-analysis-paragraph">
          <p>{data?.overview || "No analysis available."}</p>
        </div>
      </div>
    </div>
  )
}

export default InternalMobilityMetricsReport
